import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { 
	AUTH_PREFIX_PATH, 
	UNAUTHENTICATED_ENTRY, 
	REDIRECT_URL_KEY 
} from 'configs/AppConfig';
import {RootState} from "store";

const ProtectedRoute = () => {
	
	const { auth_token } = useSelector((state: RootState) => state.auth);
	const location = useLocation();

	if (!auth_token) {
		return <Navigate
			to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
			replace
		/>;
	}

	return <Outlet />;
};

export default ProtectedRoute;